import Vue from 'vue'
import Router from 'vue-router'
import Provider from '@/Provider'
import ProviderList from '@/ProviderList'

Vue.config.productionTip = false

Vue.use(Router)

export const router = new Router({
  routes: [
    {
      path: '/',
      redirect: { name: 'ProviderList' }
    },
    {
      name: 'ProviderList',
      path: '/providers',
      component: ProviderList,
      props: true
    },
    {
      name: 'Provider',
      path: '/provider/:id(\\d+)',
      component: Provider,
      props: true
    }
  ],
  scrollBehavior (to, from, savedPos) {
    if (savedPos) {
      return savedPos
    } else {
      return {
        selector: '.main-menu-bar'
      }
    }
  }  
})
